import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CustomCarousel from "../../components/carousel";
import ReviewCard from '../../components/ReviewCard';
import StarRating from '../../components/rating';
import Card from "../../components/Card";
import businessImg from '../../images/business.svg'
import line from '../../images/icons/line.svg'
import mark from '../../images/icons/mark.svg'
import envelope from '../../images/icons/envolope.svg'
import call from '../../images/icons/call.svg';
import web from '../../images/icons/web.svg'
import emailConfirm from '../../images/emailConfirm.svg'

const BusinessBody = () => {
  const { businessName } = useParams(); // Extract the business name from the URL
  const [businessInfo, setBusinessInfo] = useState(1);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/businesses/${businessName}`);

        if (response.ok) {
          const data = await response.json();
          setBusinessInfo(data.data ?? data);
        } else if (response.status === 404) {
          navigate("/");
        } else {
          console.error("Unexpected response status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching business info:", error);
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessInfo();
  }, [businessName, navigate]);


      const [reviews, setReviews] = useState([
          {name:'',title:'',review:'Very satisfied with the service.its efficient and very professional'},
          {name:'',title:'Good Work',review:'Teamsold their service is 100 % and in terms of getting buyers or sell on your behalf they are just the best and they promise and deliver tbk u tnk you teamsold keep up the food work'},
          {name:'',title:'',review:'Keep on doing a very great job...putting all efforts in ensuring one obtains a home meeting their needs...'},
          {name:'',title:'',review:'I have travelled across the whole world ,I have never got good service like I got.You are the best'},
      ])
  
      const [openingHours, setOpeningHours] = useState([
          {day:'Monday',opening:'08:00',closing:'16:00'},
          {day:'Tuesday',opening:'08:00',closing:'16:00'},
          {day:'Wednesday',opening:'08:00',closing:'16:00'}
      ])
  
          const [cards, setCards] = useState([
              {
                  image: 'https://via.placeholder.com/300', 
                  label: 'Agriculture',
                  title: 'Merilek Scholars',
                  rating: 4,
                  recommendations: '1234',
                  address: '3891 Ranchview Dr. Richardson, California 62639',
              },
              {
                  image: 'https://via.placeholder.com/300', 
                  label: 'Agriculture',
                  title: 'Merilek Scholars',
                  rating: 4,
                  recommendations: '1234',
                  address: '3891 Ranchview Dr. Richardson, California 62639',
              },
              {
                  image: 'https://via.placeholder.com/300', 
                  label: 'Agriculture',
                  title: 'Merilek Scholars',
                  rating: 4,
                  recommendations: '1234',
                  address: '3891 Ranchview Dr. Richardson, California 62639',
              },
              {
                  image: 'https://via.placeholder.com/300', 
                  label: 'Agriculture',
                  title: 'Merilek Scholars',
                  rating: 4,
                  recommendations: '1234',
                  address: '3891 Ranchview Dr. Richardson, California 62639',
              },
              {
                  image: 'https://via.placeholder.com/300', 
                  label: 'Agriculture',
                  title: 'Merilek Scholars',
                  rating: 4,
                  recommendations: '1234',
                  address: '3891 Ranchview Dr. Richardson, California 62639',
              },
              {
                  image: 'https://via.placeholder.com/300', 
                  label: 'Agriculture',
                  title: 'Merilek Scholars',
                  rating: 4,
                  recommendations: '1234',
                  address: '3891 Ranchview Dr. Richardson, California 62639',
              }
          ])
  
      const [isOpen, setIsOpen] = useState(false);
  
      const openModal = () => setIsOpen(true);
      const closeModal = () => setIsOpen(false);
      const [userRating, setUserRating] = useState(0); 
      const handleRatingChange = (newRating) => {
          setUserRating(newRating);
        };
      
      const [startRecommendation, setStartRecommendation] = useState(0)
      const [emailSent, setEmailSent] = useState(0)
      const [email, setEmail] = useState(0)
  
      const sendEmail = (e) => {
          setStartRecommendation(0)
          e.preventDefault()
          setEmailSent(1)
      }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="loader mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!businessInfo) {
    return null;
  }

  if (!loading && businessInfo) {
  return (
    <>
    { startRecommendation ? (
        <>
        <div>
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40" onClick={closeModal}></div>
            <div className="fixed inset-0 z-50 flex items-center justify-center text-start">
                <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6">
                <div className="flex justify-between items-center">
                    <h2 className="text-xl font-semibold">Provide Recommendation</h2>
                    <button
                    onClick={() => setStartRecommendation(0)}
                    className="text-gray-400 hover:text-gray-600"
                    >
                    &times;
                    </button>
                </div>
                <form className="mt-4" onSubmit={sendEmail}>
                    <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">
                        Email
                    </label>
                    <input
                        type="email"
                        placeholder="Email"
                        required
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                    </div>
                    <button
                    type="submit"
                    className="w-full bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600"
                    >
                    Begin Recommendation
                    </button>
                </form>
                </div>
            </div>
            </div>
        </>
    ) : ''
    }

{ emailSent ? (
        <>
        <div>
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40" onClick={closeModal}></div>
            <div className="fixed inset-0 z-50 flex items-center justify-center text-start">
                <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6">
                <div className="flex justify-between items-center">
                    <h2 className="text-xl font-semibold"></h2>
                    <button
                    onClick={() => setEmailSent(0)}
                    className="text-gray-400 hover:text-gray-600"
                    >
                    &times;
                    </button>
                </div>
                <form className="mt-4">
                    <div className="mb-3 flex flex-col items-center">
                        <span><img src={emailConfirm} /></span>
                        <span className='text-[#667085]'>We have sent a link to <span className='text-[#008B39]'>{email}</span> for you to continue your recommendation. After receiving the email follow the link provided to recommend a business successfully. </span>
                    </div>
                    <button
                    type="button" onClick={() => setEmailSent(0)}
                    className="w-full bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600"
                    >
                    Cancel
                    </button>
                </form>
                </div>
            </div>
            </div>
        </>
    ) : ''
    }
    {isOpen && (
    <div>
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40" onClick={closeModal}></div>
      <div className="fixed inset-0 z-50 flex items-center justify-center text-start">
        <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold">Write a review</h2>
            <button
              onClick={closeModal}
              className="text-gray-400 hover:text-gray-600"
            >
              &times;
            </button>
          </div>
          <form className="mt-4">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Name
              </label>
              <input
                type="text"
                placeholder="First name"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Rating
              </label>
              <div className="">
                <StarRating 
                    rating={userRating} 
                    maxRating={5} 
                    onRatingChange={handleRatingChange} 
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Review
              </label>
              <input
                type="text"
                placeholder="Header"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>
            <div className="mb-4">
              <textarea
                placeholder="Type review details here"
                className="w-full h-32 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600"
            >
              Submit review
            </button>
          </form>
        </div>
      </div>
    </div>
    )}
    <div className='flex flex-col p-5 lg:p-20'>
        <div className='rounded-[8px] border-[1px] px-5 pb-8 lg:p-10 flex flex-col lg:flex-row lg:space-x-5 items-center'>
            <div><img className='w-[388px] h-[330.29px] rounded-[8px]' src={businessImg} /></div>
            <div className='flex flex-col text-start space-y-8'>
                <div className='flex flex-col'>
                    <span className='text-[24px] lg:text-[44px] font-[500]'>TeamSOLD Realty</span>
                    <div className='flex flex-row space-x-1 lg:space-x-3 items-center'>
                        <div>
                            <StarRating 
                                rating={4.5} 
                                maxRating={5} 
                                readOnly 
                            />
                        </div>
                        <div><img src={line} /></div>
                        <div>13 Recommendations</div>
                    </div>
                </div>
                <div className='flex flex-col lg:flex-row space-y-3 lg:space-y-0 lg:space-x-5'>
                    <span onClick={openModal} className='cursor-pointer rounded-[32px] bg-white border-[1px] border-[#008B39] text-[#008B39] px-4 py-3 text-center'>Write Review</span>
                    <span onClick={() => setStartRecommendation(1)} className='cursor-pointer rounded-[32px] bg-[#008B39] text-white px-4 py-3 text-center'>Provide Recommendation</span>
                </div>
            </div>
        </div>
        <div className='grid grid-cols-8 mt-10 space-x-8'>
            <div className='col-span-8 lg:col-span-6'>
                <CustomCarousel
                    defaultItemsPerSlide={1}
                    defaultRows={2}
                    responsive={[
                        { breakpoint: 1024, itemsPerSlide: 1, rows: 2 },
                        { breakpoint: 768, itemsPerSlide: 2, rows: 2 },
                        { breakpoint: 480, itemsPerSlide: 2, rows: 3 },
                    ]}
                >
                    {reviews.map((item, index) => (
                        <ReviewCard key={index} className="" {...item}></ReviewCard>
                    ))}
                </CustomCarousel>
            </div>
            <div className='col-span-8 lg:col-span-2 rounded-[8px] border-[1px] p-2 flex flex-col space-y-3 text-start'>
                <div className='flex flex-col'>
                    <span className='text-[#141414] text-[18px]'>About TeamSOLD Realty</span>
                    <span className='text-[#737373]'>
                        TeamSOLD is the most vibrant and dynamic real estate agency with head quarters in Pietermaritzburg, Kwazulu Natal. We ensure that the professionalism you deserve is always a priority in our relationship with you in property sales, purchase, rentals or management.

                        We bring into the real estate profession over 17years of impeccable experience and a lot of award-winning accolades for outstanding service for which we are known. TeamSOLD versatile management has given us an edge over our competitors in having a clear understanding of our clients’ needs. 

                        Our Principal/Lead Agent/Associate Mr Kenny Emedo is a multi-award winning and celebrated real estate professional with many years’ experience in the South African real estate profession. He holds a Bachelor’s Degree in Accounting; Master of Business Administration in Banking and Finance; Bachelor of Law (LLB), and has NQF4 & 5 in Real Estate. Mr Emedo was a former banker, and an astute serial entrepreneur with many start-ups in diverse businesses. He has served as a former Director Institute of Estate Agents South Africa (IEASA-Johannesburg Metro Branch); Former founding interim Vice Chairman Gauteng-Real Estate Business Owners Association (REBOSA); and was nominated to serve on the accounting committee on behalf of real estate in Services SETA. His watch word is EXCELLENCE IN SERVICE.

                        We understand our clients’ unspoken word SOLD. Therefore, we keep to our word and promise to always deliver excellent services beyond the call of duty. Our utmost trophy, after service is to win your referrals and form a family relationship bond with our clients based on the exceptional quality of service we delivered and established trust.

                        TeamSOLD is your one stop real estate support. Always ready to serve you.
                    </span>
                    <hr className='mt-3'></hr>
                </div>
                <div className='flex flex-col '>
                    <span className='text-[#141414] text-[18px] mb-2'>Contact</span>
                    <div className='text-[#737373] flex flex-col space-y-2'>
                        <div className='flex flex-row space-x-2'>
                            <div><img src={mark} /></div>
                            <div>LNgyuierr</div>
                        </div>
                        <div className='flex flex-row space-x-2'>
                            <div><img src={envelope} /></div>
                            <div>LNgyuierr</div>
                        </div>
                        <div className='flex flex-row space-x-2'>
                            <div><img src={call} /></div>
                            <div>LNgyuierr</div>
                        </div>
                        <div className='flex flex-row space-x-2'>
                            <div><img src={web} /></div>
                            <div>LNgyuierr</div>
                        </div>
                    </div>
                    <hr className='mt-3'></hr>
                </div>
                <div className='flex flex-col '>
                    <span className='text-[#141414] text-[18px] mb-2'>Opening Hours</span>
                    <div className='text-[#737373] flex flex-col space-y-2'>
                        {openingHours.map(({day,opening,closing}) => {
                            return (
                                <div className='flex flex-row space-x-2'>
                                    <div>{day}</div>
                                    <div>{opening}</div>
                                    <div>-</div>
                                    <div>{closing}</div>
                                </div>
                            )
                        })}
                    </div>
                    <hr className='mt-3'></hr>
                </div>
            </div>  
        </div>
        <div className='flex flex-col space-y-3'>
            <span className='text-start font-[500] text-[20px] lg:text-[36px]'>Similar Businesses</span>
            <div>
                <CustomCarousel
                    defaultItemsPerSlide={3}
                    defaultRows={3}
                    responsive={[
                        { breakpoint: 1024, itemsPerSlide: 1, rows: 2 },
                        { breakpoint: 768, itemsPerSlide: 2, rows: 2 },
                        { breakpoint: 480, itemsPerSlide: 2, rows: 3 },
                    ]}
                >
                    {cards.slice(0,6).map((item, index) => (
                        <Card key={index} className="" {...item}></Card>
                    ))}
                </CustomCarousel>
            </div>
        </div>
    </div>
    </>
  );
}
};

export default BusinessBody;
